import { input, Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-table-state-card',
  template: `
    <p class="table-state-card__title">{{ title() }}</p>

    @if (description(); as description) {
      <p class="table-state-card__description">{{ description }}</p>
    }

    <ng-content />
  `,
  styleUrl: './table-state-card.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'table-state-card',
  },
})
export class TableStateCard {
  public readonly title = input.required<string>();
  public readonly description = input<string>();
}
